var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    ..._vm.containerStyle,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  })},[_c('div',{style:({
      ..._vm.containerBgStyle,
      position: 'absolute',
      zIndex: 0,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundPositionX: 'center',
    })}),(_vm.isShowFloatTop)?_c('FloatTop',{attrs:{"pageName":"MicrositeLogin","campaign":_vm.campaign,"isShowRedirectHome":_vm.isShowFloatTop}}):_vm._e(),_c('FloatBottom',{attrs:{"pageName":"MicrositeLogin","campaign":_vm.campaign}}),(_vm.survey)?_c('Survey',{staticStyle:{"height":"fit-content","z-index":"1"},style:({
      paddingTop: _vm.isShowFloatTop ? '52px' : '0px',
    }),attrs:{"survey":_vm.survey}}):_vm._e(),(_vm.campaign.is_show_footer)?_c('v-footer',{attrs:{"padless":""}},[_c('v-col',{staticClass:"text-center footer",attrs:{"cols":"12"}},[_c('p',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.campaign.footer_text)}})])],1):_vm._e(),_c('DialogVerifyOtp',{ref:"refVerifyOTP",attrs:{"dialogOtp":_vm.dialogOtp,"ref_code":_vm.ref_code,"site":_vm.site},on:{"close":function($event){_vm.dialogOtp = false},"verifyOtp":_vm.verifyOtp,"sendOtp":_vm.sendOtp},model:{value:(_vm.dialogOtp),callback:function ($$v) {_vm.dialogOtp=$$v},expression:"dialogOtp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }